import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "app-color-theme";

type Theme = "light" | "dark";

function getStoredTheme(): Theme { 
    try {
        return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
    }
    catch {
        return "light";
    }
}

function applyTheme(theme: Theme) {
    document.documentElement.setAttribute("data-theme", theme);
}

export function useTheme() {
    const [theme, setTheme] = useState<Theme>(getStoredTheme());

    useEffect(() => {
        applyTheme(theme);
        localStorage.setItem(STORAGE_KEY, theme);
    }, [theme]);

    const isDarkMode = theme === "dark";

    const toggleTheme = useCallback(() => {
        setTheme((current) => (current === "dark" ? "light" : "dark"));
    }, []);

    return { theme, isDarkMode, toggleTheme, setTheme}
}